import { FinleyAi } from '@finley-technologies/finley-types';

// Add pre-configured question config templates
export const PRE_CONFIGURED_TEMPLATES: {
  name: string;
  config: FinleyAi.FinleyAiVirtualSheetFormulaQuestions;
}[] = [
  {
    name: 'Multiple Loan Products Borrowing Base Extraction',
    config: [
      {
        fieldName: 'loanProductSlug',
        fieldPrompt:
          'hardcoded: experityVenturesCapitalOneLoanProduct, experityVenturesSynovusLoanProduct, experityVenturesEwbLoanProduct.',
      },
      {
        fieldName: 'totalReceivableExposure',
        fieldPrompt: 'What is the total receivable exposure?',
      },
      {
        fieldName: 'totalEligibleExposure',
        fieldPrompt: 'What is the total eligible exposure?',
      },
      {
        fieldName: 'eligibleExposureLessConcentrationKickouts',
        fieldPrompt:
          'What is the eligible exposure less concentration kickouts?',
      },
      {
        fieldName: 'totalConcentrationKickout',
        fieldPrompt: 'What is the total concentration kickout?',
      },
      {
        fieldName: 'borrowingBaseAmount',
        fieldPrompt: 'What is the borrowing base amount?',
      },
      {
        fieldName: 'assetValuation',
        fieldPrompt: 'What is the asset valuation?',
      },
      {
        fieldName: 'performingExposure',
        fieldPrompt: 'What is the performing exposure?',
      },
      {
        fieldName: 'totalEligibilityKickout',
        fieldPrompt: 'What is the total eligibility kickout?',
      },
    ],
  },
  {
    name: 'Single Loan Product borrowing base Extraction',
    config: [
      {
        fieldName: 'loanProductSlug',
        fieldPrompt: 'hardcoded: myLoanProductSlug',
      },
      {
        fieldName: 'totalReceivableExposure',
        fieldPrompt: 'What is the total receivable exposure?',
      },
      {
        fieldName: 'totalEligibleExposure',
        fieldPrompt: 'What is the total eligible exposure?',
      },
      {
        fieldName: 'eligibleExposureLessConcentrationKickouts',
        fieldPrompt:
          'What is the eligible exposure less concentration kickouts?',
      },
      {
        fieldName: 'totalConcentrationKickout',
        fieldPrompt: 'What is the total concentration kickout?',
      },
      {
        fieldName: 'borrowingBaseAmount',
        fieldPrompt: 'What is the borrowing base amount?',
      },
      {
        fieldName: 'assetValuation',
        fieldPrompt: 'What is the asset valuation?',
      },
      {
        fieldName: 'performingExposure',
        fieldPrompt: 'What is the performing exposure?',
      },
      {
        fieldName: 'totalEligibilityKickout',
        fieldPrompt: 'What is the total eligibility kickout?',
      },
    ],
  },
  {
    name: 'Simple Test Template',
    config: [
      {
        fieldName: 'earth_number',
        fieldPrompt: 'what is planet earth number',
      },
      {
        fieldName: 'mars_number',
        fieldPrompt: 'what is planet mars number',
      },
    ],
  },
];
